import { withInstall } from '@zoryn/utils'
import CollapseTransition from './src/collapse-transition.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCollapseTransition: SFCWithInstall<typeof CollapseTransition> =
  withInstall(CollapseTransition)

export default ZCollapseTransition
